import { FC, ReactNode } from 'react';
import { Tab } from '@headlessui/react';

export interface TabType {
  id: string;
  value: string;
  title?: ReactNode;
  content: () => ReactNode;
}

interface TabsProp {
  defaultIndex?: number;
  value?: string;
  onItemSelect: (item: TabType) => void;
  items: TabType[];
  className?: string;
}

const Tabs: FC<TabsProp> = ({ onItemSelect, items, value, className, defaultIndex }) => {
  return (
    <div className="flex flex-col">
      <Tab.Group {...(defaultIndex !== undefined ? { defaultIndex } : {})}>
        <Tab.List
          className={`flex flex-nowrap justify-evenly sm:justify-start bg-white dark:bg-slate-800 rounded-xl p-1.5 gap-1 ${
            className || ''
          }`.trim()}
        >
          {items &&
            items.length > 0 &&
            items.map((item) => (
              <Tab
                className="cursor-pointer flex-1 sm:flex-none sm:min-w-[160px] outline-none focus:outline-none"
                key={item.id}
                onClick={() => onItemSelect(item)}
              >
                <div
                  className={`inline-block px-4 py-2.5 w-full rounded-lg font-medium text-sm transition-all duration-200 ${
                    value === item.value
                      ? 'bg-gradient-to-r from-orange to-orange/90 dark:from-teal-500 dark:to-teal-600 text-white shadow-md'
                      : 'text-gray-600 dark:text-gray-400 hover:text-gray-900 dark:hover:text-white hover:bg-gray-100 dark:hover:bg-slate-700'
                  }`}
                >
                  {item.title}
                </div>
              </Tab>
            ))}
        </Tab.List>
        <Tab.Panels className="mt-5 w-full">
          {items &&
            items.length > 0 &&
            items.map((item) => (
              <Tab.Panel className="w-full flex flex-col" key={item.id}>
                {item.content()}
              </Tab.Panel>
            ))}
        </Tab.Panels>
      </Tab.Group>
    </div>
  );
};

export default Tabs;
